<template>
  <div class="loaded-user">
    <div
      class="user-content"
      @click="toggle(user)">
      <span :class="['user-content-value', {'user-content-active': $store.state.selectedUserId === user.id}]">
        <i class="material-icons">person</i>
        <span class="label">{{ user.name.last + user.name.first }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * このコンポーネントで扱うユーザーの情報
     */
    user: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.user.id === localStorage.getItem('selectedUserId')) {
        this.toggle(this.user)
      }
    })
  },
  methods: {
    /**
     * 選択したユーザーの日報を取得する
     * @param {Object} user 選択されたユーザー
     */
    toggle (user) {
      if (this.$store.state.selectedUserId === user.id) return
      this.$store.commit('setSelectedUserId', user.id)
    }
  }
}
</script>

<style scope>
.loaded-user {
  padding: 0 0 0 10px;
}
.user-content{
  height: 32px;
  max-width: 100%;
  padding: 0;
  display: inline-flex;
  font-size: 0.9em;
}
.user-content-value {
  color: #666;
  white-space: nowrap;
  margin: 0;
  vertical-align: top;
  line-height: 30px;
  height: 32px;
  cursor: pointer;
}
.loaded-user .material-icons {
  display: inline-flex;
  vertical-align: middle;
  height: 24px;
  width: 24px;
  margin: auto 0;
  color: #666;
}
.user-content-value:hover {
  background: #e7f4f9;
}
.loaded-user .user-content-active {
  color: #039be5;
}
.label {
  line-height: 1;
  vertical-align: middle;
}
@keyframes rotate-anime {
  100%{ transform: rotate(360deg) }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/DailyReport/MenuUserSelect.vue